module.exports = __webpack_public_path__ + "assets/img/dfa-cs.5e867f29.png";